import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=be35c498&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=be35c498&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be35c498",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('be35c498')) {
      api.createRecord('be35c498', component.options)
    } else {
      api.reload('be35c498', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=be35c498&scoped=true&", function () {
      api.rerender('be35c498', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2FKAOR5F2LF4j/JS/comp/GuestBox.vue"
export default component.exports